var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckDailyReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30.89 30.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.44,
    y1: 1.09,
    x2: 15.44,
    y2: 30.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbe00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 15.44,
    y1: 1.09,
    x2: 15.44,
    y2: 30.56,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "9.4 14.51 7.54 16.39 12.81 21.71 23.34 11.06 21.49 9.17 12.81 17.95 9.4 14.51",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.74,29.74H8.15a7,7,0,0,1-7-7V8.15a7,7,0,0,1,7-7H22.74a7,7,0,0,1,7,7V22.74A7,7,0,0,1,22.74,29.74ZM8.15,4.15a4,4,0,0,0-4,4V22.74a4,4,0,0,0,4,4H22.74a4,4,0,0,0,4-4V8.15a4,4,0,0,0-4-4Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDailyReports);
export default __webpack_public_path__ + "static/media/check_daily_reports.72f58d1be60bb548478ce91e11189d2d.svg";
export { ForwardRef as ReactComponent };